import { isEmpty, isEqual, isNil } from "lodash-es";
import FieldId from "./FieldId";
import SuperJSON from "superjson";
import { ValueReference } from "../types/ValueReference";

export type FieldValueReferenceType = "image" | "text";

export default class FieldValueReference extends ValueReference<FieldId> {
  public readonly path: string[];
  public readonly type: FieldValueReferenceType | undefined;

  constructor(fieldId: FieldId, path: string[] = [], type?: FieldValueReferenceType) {
    super(fieldId);
    this.path = path;
    this.type = type;
  }

  equals(other: this | string | undefined | null): boolean {
    if (isNil(other)) {
      return false;
    }

    if (other instanceof this.constructor) {
      return other.id.equals(this.id) && isEqual(other.path, this.path);
    }

    return other === this.toString();
  }

  toString() {
    return isEmpty(this.path) ? this.id.toString() : `${this.id}.${this.path.join(".")}`;
  }

  static from(value: string, type?: FieldValueReferenceType) {
    const [fieldId, ...sub] = value.split(".");
    return new FieldValueReference(FieldId.from(fieldId), sub, type);
  }
}

SuperJSON.registerClass(FieldValueReference, { identifier: "FieldValueReference" });

// The class name gets minified when building, but this can cause issues in our value references detection (see form version mapping)
// This is a workaround to keep a consistent class name.
Object.defineProperty(FieldValueReference, "name", { value: "FieldValueReference", configurable: true });
